/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const WifiZero = ["svg", defaultAttributes, [["path", { d: "M12 20h.01" }]]];

export { WifiZero as default };
//# sourceMappingURL=wifi-zero.js.map
